import * as React from 'react';
import { Box, Paper, Tab, Tabs, Typography } from '@mui/material';
import Login from './login';
import Register from './register';
import LayoutNoAuth from './layout';

export default function NoAuth() {
  const [value, setValue] = React.useState(0);
  const handleChange = (_: React.SyntheticEvent, newValue: number) => setValue(newValue);

  return (
    <LayoutNoAuth>
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          p: { xs: 2.5, sm: 3 },
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: 2,
          boxShadow: '0 18px 45px rgba(15, 23, 42, 0.08)',
        }}
      >
        <Box sx={{ mb: 2.5 }}>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.75 }}>
            {value === 0 ? 'Вход в аккаунт' : 'Создание аккаунта'}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {value === 0
              ? 'Введите email и пароль, чтобы продолжить учет доходов и расходов.'
              : 'Зарегистрируйтесь, чтобы начать вести личный финансовый учет.'}
          </Typography>
        </Box>

        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2.5 }}>
          <Tabs value={value} onChange={handleChange} variant="fullWidth">
            <Tab label="Вход" />
            <Tab label="Регистрация" />
          </Tabs>
        </Box>

        {value === 0 ? <Login /> : <Register />}
      </Paper>
    </LayoutNoAuth>
  );
}
